import './App.css';

import {ConfigProvider, Layout, theme} from "antd";
import {AuthProvider} from "./funcs/Authcontext";
import {Route, Routes} from "react-router-dom";
import PrivateRoutes1 from "./funcs/CheckAuth";
import Authpage from "./pages/Authpage";
import Mainpage from "./pages/Mainpage";

import ruRu from 'antd/locale/ru_RU';

function App() {
    return (
        <ConfigProvider
            locale={ruRu}
            theme={{
                algorithm: theme.darkAlgorithm,
                token: {
                    sizeUnit: 3,
                    colorPrimary: "#a017ff",
                    colorInfo: "#a017ff",
                    colorBgBase: "#120d1f",
                    colorBgLayout: "#0f0b1a",
                    fontSize: 15,
                    borderRadius: 10,
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                },
                components: {
                    Layout: {
                        bodyBg: "#0f0b1a",
                        headerBg: "#181226",
                        siderBg: "#120d1f",
                    },
                    Menu: {
                        itemSelectedBg: "rgba(160,23,255,0.18)",
                        itemSelectedColor: "#c69bff",
                        itemHoverBg: "rgba(160,23,255,0.10)",
                        itemBorderRadius: 10,
                        itemMarginInline: 0,
                    },
                    Card: {
                        colorBgContainer: "#181226",
                    },
                    Table: {
                        headerBg: "#1d1630",
                        headerColor: "#c8b3e6",
                        rowHoverBg: "rgba(160,23,255,0.08)",
                        borderColor: "#2a2140",
                        colorBgContainer: "#15101f",
                    },
                    Segmented: {
                        itemSelectedBg: "#a017ff",
                        itemSelectedColor: "#ffffff",
                        trackBg: "#1d1630",
                    },
                    Statistic: {
                        contentFontSize: 24,
                    },
                },
            }}
        >
            <Layout style={{minHeight: "100vh"}}>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Authpage/>}/>
                        <Route element={<PrivateRoutes1/>}>
                            <Route exact path='/*' element={<Mainpage/>}/>
                        </Route>
                    </Routes>
                </AuthProvider>
            </Layout>
        </ConfigProvider>
    );
}

export default App;
